import liveInstructionRoute from './live-instruction';

export default [
  {
    path: '/reports',
    redirect: { name: 'reports.overview' },
    name: 'reports',
  },
  {
    path: '/reports/overview',
    name: 'reports.overview',
    component: () =>
      import(
        /* webpackChunkName: 'reports-overview' */
        '@/views/overview-report/OverviewReportView'
      ),
  },
  {
    path: '/reports/courses-units',
    name: 'reports.units_and_courses',
    component: () =>
      import(
        /* webpackChunkName: 'reports-courses-units' */
        '@/views/courses-units-report/CoursesUnitsReportView'
      ),
    redirect: { name: 'reports.units_and_courses.units' },
    children: [
      {
        path: '/reports/courses-units/courses',
        name: 'reports.units_and_courses.courses',
        component: () =>
          import(
            /* webpackChunkName: 'reports-courses-units' */
            '@/views/courses-units-report/CoursesReportView'
          ),
        meta: { isTimeZoneSensitive: true },
      },
      {
        path: '/reports/courses-units/units',
        name: 'reports.units_and_courses.units',
        component: () =>
          import(
            /* webpackChunkName: 'reports-courses-units' */
            '@/views/courses-units-report/UnitsReportView'
          ),
        meta: { isTimeZoneSensitive: true },
      },
    ],
  },
  liveInstructionRoute,
  {
    path: '/reports/session-report',
    name: 'reports.session',
    component: () =>
      import(
        /* webpackChunkName: 'reports-session' */
        '@/views/session-report/SessionReportView'
      ),
    meta: { isTimeZoneSensitive: true },
  },
  {
    path: '/reports/vpa',
    name: 'reports.vpa',
    component: () =>
      import(
        /* webpackChunkName: 'reports-vpa' */
        '@/views/vpa-report/VpaReportView'
      ),
    meta: { isTimeZoneSensitive: true },
  },
];
